//
import { UserSellerModel } from '@/models'

/**
 *
 */
const remove = async function(id) {
    //
    try {
        //
        let user = await UserSellerModel.find(id),
            response = await user.delete()

        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default remove
